module.exports = __webpack_public_path__ + "img/202408_05.8d24a1e0.jpg";